export default "__VITE_ASSET__BvI8WX3u__"